import React from "react";
import PropTypes from "prop-types";
import * as THREE from "three";

class PlayerInfoWindow extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.closeOnClick = this.closeOnClick.bind(this);
  }

  closeOnClick() {
    this.closeInfo();
  }

  closeInfo() {
    this.props.object.opened = false;
  }

  widgetMatrix() {
    const matrix = new THREE.Matrix4();
    const position = new THREE.Vector3().setFromSpherical(
      THREE.Spherical(
        1000,
        THREE.Math.degToRad(this.props.phi),
        THREE.Math.degToRad(this.props.theta)
      )
    );
    matrix.lookAt(new THREE.Vector3(), position, new THREE.Vector3(0, 1, 0));

    let rotation = new THREE.Euler().setFromRotationMatrix(matrix, "YXZ");
    if (this.props.rotation) {
      rotation = new THREE.Euler(
        (-this.props.rotation / 180) * Math.PI,
        rotation.y,
        rotation.z,
        "YXZ"
      );
    }
    const quaternion = new THREE.Quaternion().setFromEuler(rotation);
    const scale = new THREE.Vector3(
      this.props.scale,
      this.props.scale,
      this.props.scale
    );
    matrix.compose(
      position,
      quaternion,
      scale
    );
    return matrix;
  }

  worldToScreen() {
    let matrix = this.widgetMatrix();
    let pos = new THREE.Vector3();
    pos = pos.setFromMatrixPosition(matrix);
    pos.project(this.props.perspectiveCamera);

    let widthHalf = this.props.windowWidth * 0.5;
    let heightHalf = this.props.windowHeight * 0.5;

    pos.x = pos.x * widthHalf + widthHalf;
    pos.y = -(pos.y * heightHalf) + heightHalf;
    //pos.z = 0;
    return { x: pos.x, y: pos.y, z: pos.z };
  }

  render() {
    const screenPosition = this.worldToScreen();
    var {
      name,
      icon_image: { downloadURL: iconDownloadURL = "" } = {},
      icon_width = "100px",
      window_image: { downloadURL: windowDownloadURL = "" } = {},
      window_width = "400px",
      window_height = "200px",
      window_corners = "0",
      window_positionX = "0",
      window_positionY = "0",
      window_padding = { top: 0, right: 0, bottom: 0, left: 0 },
      button_image: { downloadURL: buttonDownloadURL = "" } = {},
      button_width = "100",
      button_positionX = "0",
      button_positionY = "0",
      body
    } = this.props.prefab ? this.props.prefab : this.props.object;
    const divStyle = {
      width: "auto",
      height: "auto",
      WebkitTransform:
        "translate(" + screenPosition.x + "px, " + screenPosition.y + "px)",
      MozTransform:
        "translate(" + screenPosition.x + "px, " + screenPosition.y + "px)",
      OTransform:
        "translate(" + screenPosition.x + "px, " + screenPosition.y + "px)",
      transform:
        "translate(" + screenPosition.x + "px, " + screenPosition.y + "px)",
      cursor: "pointer",
      boxSizing: "border-box",
      display: "inline-block",
      position: "absolute",
      top: "0",
      left: "0"
    };
    return (
      <div
        className="PlayerInfoWindow"
        style={this.props.style ? this.props.style : divStyle}
      >
        {this.props.object.opened && (
          <div
            style={{
              display: screenPosition.z < 1 ? "block" : "none",
              position: "absolute",
              width: window_width,
              height: window_height,
              fontSize: "20px",
              top: window_positionY,
              left: window_positionX,
              zIndex: "100"
            }}
          >
            {windowDownloadURL !== "" && (
              <div
                style={{
                  textAlign: "left",
                  paddingTop: window_padding.top,
                  paddingRight: window_padding.right,
                  paddingBottom: window_padding.bottom,
                  paddingLeft: window_padding.left,
                  background: "url(" + windowDownloadURL + ")",
                  backgroundSize: "100% 100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%"
                }}
                dangerouslySetInnerHTML={{ __html: body }}
              />
            )}
            {windowDownloadURL == "" && (
              <div
                style={{
                  textAlign: "left",
                  paddingTop: window_padding.top,
                  paddingRight: window_padding.right,
                  paddingBottom: window_padding.bottom,
                  paddingLeft: window_padding.left,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgb(45, 228, 136)",
                  borderRadius: window_corners,
                  opacity: 0.75
                }}
                dangerouslySetInnerHTML={{ __html: this.props.object.body }}
              />
            )}
            {buttonDownloadURL !== "" && (
              <img
                onClick={this.closeOnClick}
                onTouchStart={this.closeOnClick}
                style={{
                  position: "absolute",
                  top: button_positionY,
                  right: button_positionX,
                  width: button_width,
                  height: "auto",
                  zIndex: "101"
                }}
                src={buttonDownloadURL}
              />
            )}
            {buttonDownloadURL == "" && (
              <div
                onClick={this.closeOnClick}
                onTouchStart={this.closeOnClick}
                style={{
                  position: "absolute",
                  top: button_positionY,
                  right: button_positionX,
                  width: button_width,
                  height: button_width,
                  backgroundColor: "#CC0000",
                  borderRadius: button_width,
                  opacity: 0.75,
                  color: "white",
                  fontSize: parseInt(button_width) * 0.8 + "px",
                  fontWeight: "bold",
                  lineHeight: parseInt(button_width) * 0.9 + "px"
                }}
              >
                x
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

PlayerInfoWindow.propTypes = {
  onClick: PropTypes.func
};

export default PlayerInfoWindow;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerInfoWindow/PlayerInfoWindow.js